 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"login":"login","dashboard~detail~edition~school":"dashboard~detail~edition~school","dashboard~detail~school":"dashboard~detail~school","dashboard":"dashboard","detail":"detail","school":"school","edition":"edition","enrollment-admin":"enrollment-admin"}[chunkId]||chunkId) + "." + {"chunk-07110fec":"1ba492d7","chunk-ba99426c":"c74da798","chunk-da206d60":"df3da0f4","chunk-a5dba5c4":"09730536","chunk-00408563":"9df7446d","chunk-02a64ce8":"840a42b7","chunk-0364c7dc":"afa48dc5","chunk-0b16d44b":"e798f390","chunk-0fc4df6f":"6b16d8ab","chunk-126c925e":"077fd5b0","chunk-21e362fe":"2153020b","chunk-243374e9":"0f30c4a3","chunk-2dc68c4d":"93b2f7aa","chunk-3312c390":"95b19b84","chunk-33873b76":"745c6e82","chunk-35e386f0":"01564bb5","chunk-370736b0":"b7f1b54b","chunk-3d3a8ea0":"d3c86dec","chunk-3f2ed65b":"b6bf553a","chunk-4157424f":"647fbf99","chunk-46a6afa0":"da7393ca","chunk-4c669577":"ddaa9066","chunk-5739f059":"f8a1367c","chunk-5d8fe162":"362b7cda","chunk-736be831":"180138ac","chunk-75153f09":"9a42279c","chunk-ad0b6852":"0cc4ef93","chunk-b17347ec":"0fe9ddfb","chunk-b9b7c43c":"2eaa3fbb","chunk-df6e41fc":"346234bd","chunk-fe026af4":"2a4bd571","login":"6e02acfc","dashboard~detail~edition~school":"7c87fc38","dashboard~detail~school":"4c59c0ce","dashboard":"80940116","detail":"2f66cb4c","school":"9e7b0ada","edition":"c8b38f7c","chunk-0fdecd2c":"f60d2128","chunk-1a7df63e":"b0f3389e","chunk-1dd311f7":"9f689662","chunk-2d0ae634":"23676d03","enrollment-admin":"75ed0ed4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-07110fec":1,"chunk-ba99426c":1,"chunk-da206d60":1,"chunk-a5dba5c4":1,"chunk-00408563":1,"chunk-02a64ce8":1,"chunk-0364c7dc":1,"chunk-0b16d44b":1,"chunk-0fc4df6f":1,"chunk-126c925e":1,"chunk-21e362fe":1,"chunk-243374e9":1,"chunk-2dc68c4d":1,"chunk-3312c390":1,"chunk-33873b76":1,"chunk-35e386f0":1,"chunk-370736b0":1,"chunk-3d3a8ea0":1,"chunk-3f2ed65b":1,"chunk-4157424f":1,"chunk-46a6afa0":1,"chunk-4c669577":1,"chunk-5739f059":1,"chunk-5d8fe162":1,"chunk-736be831":1,"chunk-75153f09":1,"chunk-ad0b6852":1,"chunk-b17347ec":1,"chunk-b9b7c43c":1,"chunk-df6e41fc":1,"chunk-fe026af4":1,"login":1,"dashboard~detail~edition~school":1,"dashboard~detail~school":1,"dashboard":1,"detail":1,"edition":1,"chunk-0fdecd2c":1,"chunk-1a7df63e":1,"chunk-1dd311f7":1,"enrollment-admin":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"login":"login","dashboard~detail~edition~school":"dashboard~detail~edition~school","dashboard~detail~school":"dashboard~detail~school","dashboard":"dashboard","detail":"detail","school":"school","edition":"edition","enrollment-admin":"enrollment-admin"}[chunkId]||chunkId) + "." + {"chunk-07110fec":"1531600f","chunk-ba99426c":"d23f6fec","chunk-da206d60":"89a6d26e","chunk-a5dba5c4":"116eb4ae","chunk-00408563":"fda7a066","chunk-02a64ce8":"4afddf34","chunk-0364c7dc":"ae7db2b1","chunk-0b16d44b":"9bdc9165","chunk-0fc4df6f":"cfe317cb","chunk-126c925e":"437057ee","chunk-21e362fe":"81aef3fa","chunk-243374e9":"020de040","chunk-2dc68c4d":"187e45ba","chunk-3312c390":"f8c38011","chunk-33873b76":"e6e32805","chunk-35e386f0":"0dd9e4ce","chunk-370736b0":"1fa130d7","chunk-3d3a8ea0":"a4516308","chunk-3f2ed65b":"d253099c","chunk-4157424f":"8894962c","chunk-46a6afa0":"3f2d379f","chunk-4c669577":"d61b274c","chunk-5739f059":"1a304214","chunk-5d8fe162":"f55afbe8","chunk-736be831":"d4307341","chunk-75153f09":"2c687809","chunk-ad0b6852":"3a79f255","chunk-b17347ec":"8b243bc2","chunk-b9b7c43c":"5cf93c9e","chunk-df6e41fc":"ea9638a3","chunk-fe026af4":"c819e632","login":"1d8c7a2b","dashboard~detail~edition~school":"6165b056","dashboard~detail~school":"8a5fecad","dashboard":"a3ebaf9b","detail":"5963624a","school":"31d6cfe0","edition":"5963624a","chunk-0fdecd2c":"476443f3","chunk-1a7df63e":"fae4c610","chunk-1dd311f7":"3b2ab6e5","chunk-2d0ae634":"31d6cfe0","enrollment-admin":"ad10a8c9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
